export const FETCH_SALESMANAGO_CONTACT_ID = 'FETCH_SALESMANAGO_CONTACT_ID';

export function fetchSalesmanagoContactId(): any {
  return ({ httpGet }: { httpGet: (path: string, params: Record<string, any>, params2: Record<string, any>) => any }) => ({
    type: FETCH_SALESMANAGO_CONTACT_ID,
    payload: {
      promise: httpGet('/client/salesmanago/contact-id', {}, { accept: 'application/json' }),
    },
  });
}
